<template>
  <v-content class="bg-content-4">
    <div class="form-container">
      <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/EmailIcon.png">
                        </v-avatar>
              Email Notify
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <!-- <VoiceSearchBar style="margin-top: 20px; margin-left: 20px;" /> -->

          </v-app-bar>
          <br />
      <!-- Form for Adding/Editing Notification Criteria -->
      <v-card class="notification-form">
        <v-card-title>
          <span class="headline">{{ editing ? 'Edit' : 'Add' }} Notification Criteria</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field class="input" v-model="form.sender" label="Sender Email"></v-text-field>
          
              </v-col>
              <v-col cols="6">
              
                <v-text-field class="input" v-model="form.subjectKeyword" label="Subject Keyword"></v-text-field>
            
              </v-col>
              <v-col cols="12">
              
              <v-btn color="blue darken-1" @click="saveNotificationCriteria">{{ editing ? 'Update' : 'Save' }}</v-btn>
            </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      
    </div>

    <div class="requests-container">
      <div class="pending-requests">
      <h3>Pending</h3>
    <saved-notifications
  :saved-notifications="emailNotificationCriteria"
  @edit="editSavedNotification"
  @delete="deleteSavedNotification"
></saved-notifications>
</div>
      <div class="completed-requests">
        <h3>Completed</h3>
        <div v-for="criteria in completedRequests" :key="criteria.id" class="notification-item">
          <!-- Display Completed Notification Criteria -->
          <div>
            <p>Sender: {{ criteria.sender }}</p>
            <p>Subject Keyword: {{ criteria.subjectKeyword }}</p>
            <v-icon color="green">mdi-check-circle</v-icon>
          </div>
        </div>
      </div>
    </div>
    <br />
  </v-content>
</template>


<script>
import SavedNotifications from "../components/SavedNotifications.vue";

export default {
  name: 'EmailNotificationComponent',
  data() {
    return {
      dialog: false,
      editing: false,
      pollingInterval: null,
      form: {
        id: null,
        sender: '',
        subjectKeyword: '',
        notified: false,
      },
      emailNotificationCriteria: [
        
        // ... more criteria objects as needed
      ],
    };
  },
  components: {
    // User,
    SavedNotifications,
  },
  computed: {
    pendingRequests() {
      return this.emailNotificationCriteria.filter(criteria => !criteria.notified);
    },
    completedRequests() {
      return this.emailNotificationCriteria.filter(criteria => criteria.notified);
    },
  },
  methods: {
    listMessages() {
      window.gapi.client.gmail.users.messages.list({
        userId: 'me',
        labelIds: 'UNREAD',
        maxResults: 10, // Consider only the top 10 unread emails
      }).then((response) => {
        const messages = response.result.messages;
        if (messages) {
          messages.forEach(message => {
            this.getMessageDetails(message.id);
          });
        }
      });
    },

    getMessageDetails(messageId) {
      window.gapi.client.gmail.users.messages.get({
        userId: 'me',
        id: messageId,
      }).then((response) => {
        const emailData = this.parseEmailData(response.result);
        this.checkEmailNotificationCriteria(emailData);
      });
    },

    parseEmailData(email) {
      const headers = email.payload.headers;
      let emailData = {
        sender: headers.find(header => header.name === 'From')?.value,
        subject: headers.find(header => header.name === 'Subject')?.value,
        // ... other relevant fields
      };
      return emailData;
    },

    checkEmailNotificationCriteria(emailData) {
      this.emailNotificationCriteria.forEach(criteria => {
        if (emailData.sender.includes(criteria.sender) &&
            emailData.subject.includes(criteria.subjectKeyword)) {
          this.notifyUser(criteria);
          criteria.notified = true; // Update criteria as notified
        }
      });
    },

    notifyUser(criteria) {
      console.log("Email received matching criteria:", criteria);
      new Audio('path_to_notification_sound.mp3').play(); // Play notification sound
      alert(`New email received: Sender - ${criteria.sender}, Subject Keyword - ${criteria.subjectKeyword}`);
    },

    // ... other methods like addNotification, editNotification, deleteNotification, etc.

    startPolling() {
      if (!this.pollingInterval) {
        this.pollingInterval = setInterval(this.listMessages, 300000); // Poll every 5 minutes
      }
    },

    addNotification() {
      this.resetForm();
      this.dialog = true;
    },
    editNotification(criteria) {
      this.form = { ...criteria };
      this.editing = true;
      this.dialog = true;
    },
    saveNotificationCriteria() {
  const newCriteria = { 
    id: this.form.id || Date.now(), 
    sender: this.form.sender, 
    subjectKeyword: this.form.subjectKeyword, 
    notified: false 
  };

  if (this.editing) {
    const index = this.emailNotificationCriteria.findIndex(n => n.id === newCriteria.id);
    if (index !== -1) {
      this.emailNotificationCriteria.splice(index, 1, newCriteria);
    }
  } else {
    this.emailNotificationCriteria.push(newCriteria);
  }
  this.resetForm();
  this.dialog = false;
  this.editing = false;
},
editSavedNotification(index) {
  const criteria = this.emailNotificationCriteria[index];
  this.form = { ...criteria };
  this.editing = true;
  this.dialog = true;
},

deleteSavedNotification(index) {
  this.emailNotificationCriteria.splice(index, 1);
},

    async checkEmails() {
      // Check the top 10 emails for each pending request
      for (let criteria of this.pendingRequests) {
        const response = await window.gapi.client.gmail.users.messages.list({
          userId: 'me',
          q: `is:unread from:${criteria.sender} ${criteria.subjectKeyword ? 'subject:' + criteria.subjectKeyword : ''}`,
          maxResults: 10,
        });
        const messages = response.result.messages;
        if (messages && messages.length > 0) {
          this.notifyUser(messages, criteria);
          criteria.notified = true; // Update criteria as notified
        }
      }
    },

    deleteNotification(id) {
      this.emailNotificationCriteria = this.emailNotificationCriteria.filter(n => n.id !== id);
    },
    closeDialog() {
      this.resetForm();
      this.dialog = false;
      this.editing = false;
    },
    resetForm() {
      this.form = { id: null, sender: '', subjectKeyword: '', notified: false };
    },
    async initializeGapiClient() {
      console.log('Init Google Client');
      await window.gapi.client.init({
        apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest', 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
      });

      let tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'https://mail.google.com/',
        callback: '', // Callback defined later
      });

      tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
          throw resp;
        }
        this.listMessages();
        // Additional functionalities can be called here
      };

      if (window.gapi.client.getToken() === null) {
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        tokenClient.requestAccessToken({ prompt: '' });
      }
    },
  },
  mounted() {
    // Load the Google API script and then initialize the client
    if (!window.gapi) {
      const script = document.createElement('script');
      script.src = 'https://apis.google.com/js/api.js';
      script.onload = () => {
        window.gapi.load('client:auth2', this.initializeGapiClient);
      };
      document.body.appendChild(script);
    } else {
      this.initializeGapiClient();
    }
  },
  beforeDestroy() {
    // Clear polling interval when component is destroyed
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
};
</script>

<style scoped>
.form-container {
  max-width: 100%;
  justify-content: space-between;
  margin-block: 30px 30px 30px 30px;
  margin-top: 0px;
  margin-bottom: 50px;
  margin-left: 50px;
  margin-right: 50px;
}

.notification-form {
  padding: 20px 20px 20px 20px;
  background-color: rgba(108, 108, 130, 0.476);
  border-radius: 15px;
  /* Additional styles for form container */
}
.requests-container {
  display: flex;
  justify-content: space-between;
  margin-block: 20px 20px 20px 20px;
}

.pending-requests {
  width: 45%;
  margin-left: 50px;
  padding: 20px 20px 20px 20px;
  background-color: rgba(41, 43, 83, 0.476);
  border-radius: 15px;
  /* Additional styles for request containers */
}
.completed-requests {
  width: 45%;
  margin-right: 50px;
  padding: 20px 20px 20px 20px;
  background-color: rgba(25, 26, 39, 0.476);
  border-radius: 15px;
}

.notification-item {
  margin-bottom: 20px;
    display: flexbox;
  justify-content: space-between;
  margin-block: 20px 20px 20px 20px;
  /* Styles for each notification item */
}
.input {
  width: 100%;
}
</style>
